import { useEffect, useState } from "react";
import {
  DatabaseOutlined,
  FolderOpenOutlined,
  ProjectOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { RootState } from "../store/store";
import { menuCloseDrawner, menuItemSelected } from "../actions/menuAction";
import { resourceTypeEnum } from "../types/resourceType";
import {
  AddDataseRoute,
  cleanDatasetElements,
  cleanDatasetFromRoutes,
} from "../actions/datasetAction";

export const useResourceList = () => {
  const data = useSelector((state: RootState) => state.resources);
  let history = useHistory();
  const [treeData, SetTreeData] = useState([
    {
      title: "Signal",
      key: "0",
      icon: <FolderOpenOutlined />,
      selectable: false,
      children: [{ title: "", key: "1", children: [] }],
    },
  ]);
  const dispatch = useDispatch();

  const handleClick = (selectedKeysValue: React.Key[], info: any) => {
    dispatch(menuCloseDrawner());
    dispatch(menuItemSelected("0"));
    if (data?.resourceSelected?.id !== info.node.id) {
      dispatch(cleanDatasetElements());
      dispatch(cleanDatasetFromRoutes());
      dispatch(
        AddDataseRoute({
          path: "",
          name: info.node.displayName,
        })
      );
    }
    const link =
      info.node.type === resourceTypeEnum.REPORT ? "/reports" : "/datasets";
    history.push(`${link}/${info.node.id}`);
  };

  const formatData = () => {
    let key = 0;
    let childrens = data.resources.data.reduce(
      (previousValue: any, currentValue: any) => {
        currentValue.uris[0]
          .split("/")
          .reduce((acc: any, title: any, idx: any, src: any) => {
            key++;
            let temp = acc.find((o: any) => o.title === title);
            if (!temp) {
              if (idx < src.length - 1) {
                temp = {
                  title: title,
                  key: key,
                  selectable: false,
                  children: [],
                };
              } else {
                temp = {
                  id: currentValue.id,
                  type:
                    currentValue.type === resourceTypeEnum.REPORT
                      ? resourceTypeEnum.REPORT
                      : resourceTypeEnum.DATASETS,
                  title: title,
                  displayName: currentValue.displayName,
                  key: key,
                  isLeaf: true,
                  icon:
                    currentValue.type === resourceTypeEnum.REPORT ? (
                      <ProjectOutlined />
                    ) : (
                      <DatabaseOutlined />
                    ),
                  selectable: true,
                };
              }
              acc.push((temp = { ...temp }));
            }
            return temp.children;
          }, previousValue);
        return previousValue;
      },
      []
    );
    return childrens;
  };

  useEffect(() => {
    if (!data.resources.loading) {
      const copyTreeData = [...treeData];
      copyTreeData[0].children = formatData();
      SetTreeData(copyTreeData);
    }
  }, [data.resources.loading]);

  return {
    handleClick,
    treeData,
  };
};
